export const DATA_TEST_ID_PREFIX = 'microlearningdetails-'
